var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsExcludedTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -2584.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Excluded-transactions",
    transform: "translate(4262.000000, 2584.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.375,22 L16.182,22 L18.01,23.828 C18.791,24.609 18.791,25.875 18.01,26.656 L12.354,21 L18.01,15.343 C18.791,16.125 18.791,17.391 18.01,18.172 L16.182,20 L26.375,20 L26.375,22 Z M11.635,16.656 L5.979,11 L11.635,5.343 C12.416,6.125 12.416,7.391 11.635,8.172 L9.807,10 L20,10 L20,12 L9.807,12 L11.635,13.828 C12.416,14.609 12.416,15.875 11.635,16.656 L11.635,16.656 Z M16,0 C7.164,0 0,7.164 0,16 C0,24.837 7.164,32 16,32 C24.837,32 32,24.837 32,16 C32,7.164 24.837,0 16,0 L16,0 Z",
    id: 86
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsExcludedTransactions);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-excluded-transactions.56d95226.svg";
export { ForwardRef as ReactComponent };